import { render, staticRenderFns } from "./SatPopover.vue?vue&type=template&id=be1ea52e&scoped=true"
import script from "./SatPopover.vue?vue&type=script&lang=js"
export * from "./SatPopover.vue?vue&type=script&lang=js"
import style0 from "./SatPopover.vue?vue&type=style&index=0&id=be1ea52e&prod&lang=scss&scoped=true"
import style1 from "./SatPopover.vue?vue&type=style&index=1&id=be1ea52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ea52e",
  null
  
)

export default component.exports